import { useContentPublishQueue } from 'hooks/useContentPublishQueue';

const ContentPublishQueueRunner = () => {
  useContentPublishQueue();
  return null;
};

export default ContentPublishQueueRunner;
